var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173.35 173.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-4, .cls-5 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #3270fd;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #3270fd;\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .cls-2, .cls-5, .cls-3 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-5, .cls-3 {\r\n        stroke: #fff;\r\n        stroke-width: 6px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m86.68,167.36c-21.55,0-41.81-8.39-57.05-23.63-31.46-31.46-31.46-82.64,0-114.1,15.24-15.24,35.5-23.63,57.05-23.63s41.81,8.39,57.05,23.63c15.24,15.24,23.63,35.5,23.63,57.05s-8.39,41.81-23.63,57.05c-15.24,15.24-35.5,23.63-57.05,23.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m86.68,12c19.95,0,38.7,7.77,52.81,21.87,29.12,29.12,29.12,76.5,0,105.62-14.11,14.11-32.86,21.87-52.81,21.87s-38.7-7.77-52.81-21.87c-29.12-29.12-29.12-76.5,0-105.62,14.11-14.11,32.86-21.87,52.81-21.87M86.68,0C64.5,0,42.31,8.46,25.39,25.39c-33.85,33.85-33.85,88.74,0,122.59,16.93,16.93,39.11,25.39,61.29,25.39s44.37-8.46,61.29-25.39c33.85-33.85,33.85-88.74,0-122.59C131.05,8.46,108.87,0,86.68,0h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m112.28,123.95v9.75c0,4.09-3.2,7.41-7.14,7.41h-42.87c-3.95,0-7.14-3.32-7.14-7.41v-9.75s57.15,0,57.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m112.28,44.76v84.14h-57.15V44.76c0-4.1,3.2-7.41,7.14-7.41h42.87c3.95,0,7.14,3.32,7.14,7.41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 83.71,
    cy: 132.53,
    r: 4.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m55.13,43.56v-3.75c0-4.09,3.2-7.41,7.14-7.41h42.87c3.95,0,7.14,3.32,7.14,7.41v3.75h-57.15Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 78.75,
    y1: 37.98,
    x2: 88.66,
    y2: 37.98
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.74c31e04e78d2e71923d405f123e02a4.svg";
export { ForwardRef as ReactComponent };